import { useNotification } from '@aigc/antd';
import { useCallback } from 'react';
import { ParseError, parsePrompt } from './parse';

export function useTryParsePrompt(simpleMode: boolean) {
  const notification = useNotification();
  const tryParsePrompt = useCallback(
    (prompt: string) => {
      if (simpleMode) {
        return {
          prompt,
        };
      }

      try {
        const result = parsePrompt(prompt);
        return result;
      } catch (error) {
        if (error instanceof ParseError) {
          return {
            prompt,
          };
        }

        notification.error({
          title: '提示词解析失败',
          description: String(error),
        });
      }
    },
    [simpleMode, notification],
  );

  return tryParsePrompt;
}
